import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../wayfinder'
/**
* @see [serialized-closure]:2
* @route '/pulse-monitoring'
*/
export const pulse = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: pulse.url(options),
    method: 'get',
})

pulse.definition = {
    methods: ["get","head"],
    url: '/pulse-monitoring',
} satisfies RouteDefinition<["get","head"]>

/**
* @see [serialized-closure]:2
* @route '/pulse-monitoring'
*/
pulse.url = (options?: RouteQueryOptions) => {
    return pulse.definition.url + queryParams(options)
}

/**
* @see [serialized-closure]:2
* @route '/pulse-monitoring'
*/
pulse.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: pulse.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/pulse-monitoring'
*/
pulse.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: pulse.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ClientSession\ClientSessionController::home
* @see app/Http/Controllers/ClientSession/ClientSessionController.php:42
* @route '/'
*/
export const home = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

home.definition = {
    methods: ["get","head"],
    url: '/',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ClientSession\ClientSessionController::home
* @see app/Http/Controllers/ClientSession/ClientSessionController.php:42
* @route '/'
*/
home.url = (options?: RouteQueryOptions) => {
    return home.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ClientSession\ClientSessionController::home
* @see app/Http/Controllers/ClientSession/ClientSessionController.php:42
* @route '/'
*/
home.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: home.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ClientSession\ClientSessionController::home
* @see app/Http/Controllers/ClientSession/ClientSessionController.php:42
* @route '/'
*/
home.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: home.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\RegisteredUserController::register
* @see app/Http/Controllers/Auth/RegisteredUserController.php:21
* @route '/register'
*/
export const register = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: register.url(options),
    method: 'get',
})

register.definition = {
    methods: ["get","head"],
    url: '/register',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Auth\RegisteredUserController::register
* @see app/Http/Controllers/Auth/RegisteredUserController.php:21
* @route '/register'
*/
register.url = (options?: RouteQueryOptions) => {
    return register.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\RegisteredUserController::register
* @see app/Http/Controllers/Auth/RegisteredUserController.php:21
* @route '/register'
*/
register.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: register.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\RegisteredUserController::register
* @see app/Http/Controllers/Auth/RegisteredUserController.php:21
* @route '/register'
*/
register.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: register.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:21
* @route '/login'
*/
export const login = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

login.definition = {
    methods: ["get","head"],
    url: '/login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:21
* @route '/login'
*/
login.url = (options?: RouteQueryOptions) => {
    return login.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:21
* @route '/login'
*/
login.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: login.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::login
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:21
* @route '/login'
*/
login.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: login.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::logout
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:44
* @route '/logout'
*/
export const logout = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

logout.definition = {
    methods: ["post"],
    url: '/logout',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::logout
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:44
* @route '/logout'
*/
logout.url = (options?: RouteQueryOptions) => {
    return logout.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\AuthenticatedSessionController::logout
* @see app/Http/Controllers/Auth/AuthenticatedSessionController.php:44
* @route '/logout'
*/
logout.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Auth\CheckAuthController::__invoke
* @see app/Http/Controllers/Auth/CheckAuthController.php:13
* @route '/check-auth'
*/
export const checkAuth = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: checkAuth.url(options),
    method: 'get',
})

checkAuth.definition = {
    methods: ["get","head"],
    url: '/check-auth',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Auth\CheckAuthController::__invoke
* @see app/Http/Controllers/Auth/CheckAuthController.php:13
* @route '/check-auth'
*/
checkAuth.url = (options?: RouteQueryOptions) => {
    return checkAuth.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\CheckAuthController::__invoke
* @see app/Http/Controllers/Auth/CheckAuthController.php:13
* @route '/check-auth'
*/
checkAuth.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: checkAuth.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Auth\CheckAuthController::__invoke
* @see app/Http/Controllers/Auth/CheckAuthController.php:13
* @route '/check-auth'
*/
checkAuth.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: checkAuth.url(options),
    method: 'head',
})

/**
* @see \App\Modules\Dictation\Controllers\GetDictationTokenController::__invoke
* @see app/Modules/Dictation/Controllers/GetDictationTokenController.php:11
* @route '/dictation-token'
*/
export const dictationToken = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: dictationToken.url(options),
    method: 'post',
})

dictationToken.definition = {
    methods: ["post"],
    url: '/dictation-token',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Modules\Dictation\Controllers\GetDictationTokenController::__invoke
* @see app/Modules/Dictation/Controllers/GetDictationTokenController.php:11
* @route '/dictation-token'
*/
dictationToken.url = (options?: RouteQueryOptions) => {
    return dictationToken.definition.url + queryParams(options)
}

/**
* @see \App\Modules\Dictation\Controllers\GetDictationTokenController::__invoke
* @see app/Modules/Dictation/Controllers/GetDictationTokenController.php:11
* @route '/dictation-token'
*/
dictationToken.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: dictationToken.url(options),
    method: 'post',
})

